import React, { useEffect, useState } from 'react'
import { Popup } from '../../components/Popup'
import { Button } from '../../components/Button';
import { editFinishedRoute, FinishedRoute } from '../../redux/advertSlice';
import { Input } from '../../components/Input';
import { useDispatch, useSelector } from 'react-redux';

function hasChanges(data, bet, finishedDate,selectedFlyers, curAdditional, newAdditional) {
    const {bet: curBet, flyers, details: {finishedAt}} = data;
    if (bet === curBet && [...selectedFlyers].sort((a, b) => a.localeCompare(b)).join('') === flyers.map(f => f._id).sort((a, b) => a.localeCompare(b)).join('') && (finishedDate - finishedDate%1000) === (finishedAt - finishedAt%1000)) {
    } else {
        return true
    }
    for (const key in curAdditional) {
        if (curAdditional[key] !== newAdditional[key]) {
            return true
        }
    }
    return false
}
export const EditFinishRoutePopup = ({closeFn, data}) => {
    const dispatch = useDispatch();
    const flyerTypes = useSelector((state) => state.settings.flyerTypes);

    const {bet: curBet, flyers, details: {finishedAt}, additional:curAdditional} = data;

    const {addPorchCount, plusPayment, plusPaymentOwn, minusPayment, addPaymentComment} = curAdditional;

    const [selectedFlyers, selectFlyers] = useState(flyers.map(f => f._id));
    const selectFlyerHandler = (id) => {
        if (selectedFlyers.some(f => f === id)) {
            selectFlyers(prev => prev.filter(f => f !== id));
            return;
        }
        selectFlyers(prev => [...prev, id]);
    }
    const [bet, setBet] = useState(curBet);
    const [finishDate, setFinishDate] = useState(new Date(finishedAt-1000*3600*(new Date()).getTimezoneOffset()/60).toISOString().split('.')[0]);
    
    const [porchAmount, setPorchAmount] = useState(addPorchCount);
    const [offsetOwnPositive, setOffsetOwnPositive] = useState(plusPaymentOwn);
    const [offsetPositive, setOffsetPositive] = useState(plusPayment);
    const [offsetNegative, setOffsetNegative] = useState(minusPayment);
    const [offsetComment, setOffsetComment] = useState(addPaymentComment);

    const additional = {
        addPorchCount: porchAmount,
        plusPaymentOwn: offsetOwnPositive,
        plusPayment: offsetPositive,
        minusPayment: offsetNegative,
        addPaymentComment: offsetComment,
    }

    const [isDataChanged, setDataChanged] = useState(!hasChanges(data, bet, +new Date(finishDate), selectedFlyers, curAdditional, additional));
    const [isReqSended, setReqSended] = useState(false);

    useEffect(() => {
        if (hasChanges(data, bet, +new Date(finishDate), selectedFlyers, curAdditional, additional)) {
            setDataChanged(true)
            return
        }
        setDataChanged(false)
    }, [selectedFlyers,bet,finishDate,porchAmount,offsetOwnPositive,offsetPositive,offsetNegative,offsetComment])

    const hasPartnerFlyers = selectedFlyers.some(fId => !flyerTypes.find(f => f._id === fId).isOwn)

    useEffect(() => {
        if (!hasPartnerFlyers) {
            setOffsetPositive(0)
        }
    }, [selectedFlyers])

    const saveChangesHandler = () => {
        const body = {
            finishId: data._id,
            finishedAt: +new Date(finishDate),
            bet,
            flyerIds: selectedFlyers,
            additional
        }
        setReqSended(true);
        dispatch(editFinishedRoute({...body, closeFn, enableBtn: () => setReqSended(false)}));
    }

    return (
      <Popup closeWithOutsideClick={false} title='Редактировать маршрут' closeFn={closeFn} button={<Button disabled={!isDataChanged || isReqSended} text={!isDataChanged ? 'Нет изменений' : 'Сохранить'} onClick={saveChangesHandler}/>}>
            <div className='edit-finished-route-popup'>
                <p><span style={{fontWeight:'bold', fontSize:'1.1m', color:'red'}}>ВАЖНО! </span>Если Вы измените виды листовок - Вам нужно будет вручную установить соответствующие блокировки для данного маршрута</p>
                <div className='button-list'>
                    {flyerTypes.map(f => 
                    <Button key={f._id}
                    classNames={`${selectedFlyers.some(f2 => f2 === f._id)?'active':''}`}
                    text={f.name}
                    onClick={() => selectFlyerHandler(f._id)} />
                    )}
                </div>
                <Input type='number' min={0.01} step={0.01} label="Ставка" value={bet} changeHandler={(e) => setBet(+e.target.value)} />
                <Input type='datetime-local' label='Когда завершён' value={finishDate} changeHandler={(e) => setFinishDate(e.target.value)}/>
                <div className='route-additional-popup__section'>
                <p>Укажите количество подъездов, в которых листовки были оставлены у консьержа или на подоконнике</p>
                <div>
                    <Input min={0} label='Кол-во подъездов' type='number' value={porchAmount} changeHandler={(e) => setPorchAmount(+e.target.value)}/>
                    <span>x 20л. = {+porchAmount*20} листовок = + {(porchAmount*20*bet).toFixed(2)} руб прому</span>
                </div>
            </div>
            <div className='route-additional-popup__section'>
                <p>Укажите суммы, которые нужно прибавить и убавить от общей суммы маршрута (бонусы, штрафы)</p>
                <div>
                    <div>
                    <Input min={0} label='Личные начисления, руб' type='number' value={offsetOwnPositive} changeHandler={(e) => setOffsetOwnPositive(Math.abs(+e.target.value))} />
                    {hasPartnerFlyers && <Input  min={0} label='Общие начисления, руб' type='number' value={offsetPositive} changeHandler={(e) => setOffsetPositive(Math.abs(+e.target.value))} />}
                    <Input min={0} label='Отчисления, руб' type='number' value={offsetNegative} changeHandler={(e) => setOffsetNegative(Math.abs(+e.target.value))} />
                    </div>
                    <textarea className='dark-theme-bg0' value={offsetComment} placeholder={`Комментарий (необязательно)\nНапример, +бонус, -штраф`} onChange={(e) => setOffsetComment(e.target.value)} />
                </div>
            </div>
            </div>
    </Popup>
    )
}
